module.exports = __webpack_public_path__ + "static/media/LargerSimonsOpenBook.3e3b0d6a.gif";